<template>
  <section class="qrs-typography">
    <pageHeader>
      <h2 class="qrs-header-xl mt--0 mb--0">Share</h2>
    </pageHeader>

    <div class="share_screen">
      <div id="email-sent" style="display: none">
        <div class="question__nav mb--small clearfix">
          <a
            class="govuk-back-link"
            aria-label="go back to the previous screen"
            @click="goBack()"
          >
            <strong>Previous</strong>
          </a>
        </div>
        <div
          class="govuk-notification-banner"
          role="region"
          aria-labelledby="govuk-notification-banner-title"
          data-module="govuk-notification-banner"
        >
          <div class="govuk-notification-banner__header">
            <h2
              class="govuk-notification-banner__title"
              id="govuk-notification-banner-title"
            >
              Your email has been sent.
            </h2>
          </div>
          <div class="govuk-notification-banner__content">
            <p class="govuk-notification-banner__heading">
              If the person to whom you sent the email does not receive it,
              please:
            </p>
            <ol type="a">
              <li>Check the email address.</li>
              <li>
                Ask them to check their spam or junk folders. Note that they may
                need to transfer the email to their normal inbox in order to
                view the attached report.
              </li>
              <li>
                Ask them to add
                <a href="mailto:donotreply@tactuum.com">donotreply@tactuum.com</a>
                to their email whitelist.
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div
        id="email-error-send"
        style="display: none"
        class="govuk-error-summary"
        aria-labelledby="error-summary-title"
        role="alert"
        tabindex="-1"
        data-module="govuk-error-summary"
      >
        <h2 class="govuk-error-summary__title" id="error-summary-title">
          Email was not sent
        </h2>
        <div class="govuk-error-summary__body">
          <p>Please try again</p>
        </div>
      </div>
      <div
        id="email-error"
        style="display: none"
        class="govuk-error-summary"
        aria-labelledby="error-summary-title"
        role="alert"
        tabindex="-1"
        data-module="govuk-error-summary"
      >
        <h2 class="govuk-error-summary__title" id="error-summary-title">
          Email was not sent
        </h2>
        <div class="govuk-error-summary__body" v-if="this.nameError">
          <p>Please check the name that you entered and try again.</p>
        </div>
        <div class="govuk-error-summary__body" v-if="this.emailAddressError">
          <p>Please check the email address that you entered and try again.</p>
        </div>
        <div class="govuk-error-summary__body" v-if="this.recipientsError">
          <p>
            Please check the recipient email(s) that you entered and try again.
          </p>
        </div>
      </div>
      <div class="share_form" id="share_form">
        <p>
          You can email your wellbeing diary to people who can help you stay
          well. For example - a family member, a carer, a healthcare
          professional. You will need to know their email address.
        </p>

        <div class="govuk-form-group">
          <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
            <h1 class="govuk-fieldset__heading" id="name-label">Your name*</h1>
          </legend>
          <input
            v-model="name"
            type="text"
            id="name-input"
            class="govuk-input"
          />
        </div>

        <div class="govuk-form-group">
          <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
            <h1 class="govuk-fieldset__heading" id="yourEmail-label">
              Your email address*
            </h1>
          </legend>
          <input
            v-model="emailAddress"
            type="email"
            id="yourEmail-input"
            class="govuk-input"
          />
        </div>

        <div class="govuk-form-group">
          <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
            <h1 class="govuk-fieldset__heading" id="emailRecipient-label">
              Recipient email*
            </h1>
          </legend>
          <div id="email-hint" class="govuk-hint">
            To add multiple recipients, enter an email address and tap on 'Add
            recipient'
          </div>
          <input
            v-model="emailRecipient"
            type="email"
            id="emailRecipient-input"
            aria-label="recipients"
            class="govuk-input"
          />
          <div class="govuk-button--disabled" v-if="!validRecipient">
            <button
              name="Add email recipient"
              aria-label="Add email recipient"
              class="govuk-button govuk-button--secondary mt--24 mb--16"
              @click="addEmail()"
            >
              Add recipient
              <span class="screen-reader-text">Add email recipient</span>
            </button>
          </div>
          <div class="" v-if="validRecipient">
            <button
              name="Add email recipient"
              aria-label="Add email recipient"
              class="govuk-button govuk-button--secondary mt--24 mb--16"
              @click="addEmail()"
            >
              Add recipient
              <span class="screen-reader-text">Add email recipient</span>
            </button>
          </div>
          <div
            v-if="recipients.length >= 1"
            class="emails freetext__panel mb--16"
          >
            <span><strong>Recipients:</strong></span>
            <div
              class="emailtag freetext__panel__item"
              v-for="(e, idx) in recipients"
              @click="removeEmail(idx)"
              :key="idx"
            >
              <span class="emailname">{{ e }}</span>
              <span class="deletex freetext__panel__button"
                ><i class="fa fa-close"></i
              ></span>
            </div>
          </div>

          <hr class="divider" />
        </div>

        <button
          name="share-button"
          aria-label="share-button"
          class="govuk-button mt--24"
          title="Use this button to share via email"
          @click="shareViaEmail()"
        >
          <span v-if="!emailSending">Submit</span>
          <span v-if="emailSending"
            >Sending <i class="fa fa-circle-o-notch fa-spin"></i
          ></span>
        </button>
        <button
          name="cancel-button"
          aria-label="cancel-button"
          class="govuk-button govuk-button--neutral"
          title="Use this button to cancel the action"
          @click="cancelShare()"
        >
          Cancel
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import jsPDF from "jspdf";
import CryptoJS from "crypto-js";
//import axios from "axios";
import helper from "../../helpers/helper.js";

export default {
  name: "share",

  data() {
    return {
      encrypted: "",
      unencrypted: "",
      page: 1,
      name: "",
      nameError: false,
      emailAddress: "",
      emailAddressError: false,
      emailRecipient: "",
      validRecipient: null,
      recipients: [],
      recipientsError: false,
      emailSending: false,
    };
  },
  watch: {
    emailRecipient(value) {
      console.log(value);
      this.emailRecipient = value;
      this.validateRecipientEmail(value);
    },
  },
  methods: {
    goBack() {
      this.$parent.goTo(this.$MyWellbeingDiary);
    },
    resetForm() {
      this.name = "";
      this.emailAddress = "";
      this.emailRecipient = "";
      this.recipients = [];
      this.emailSending = false;
    },
    cancelShare() {
      this.$parent.goTo(this.$MyWellbeingDiary);
      this.resetForm();
    },
    validateRecipientEmail(value) {
      if (
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        )
      ) {
        this.validRecipient = true;
      } else {
        this.validRecipient = false;
      }
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateForm() {
      let errorMessage = document.getElementById("email-error");
      let nameLabel = document.getElementById("name-label");
      let emailLabel = document.getElementById("yourEmail-label");
      let recipientLabel = document.getElementById("emailRecipient-label");

      let validForm = false;

      let _hasre = false;
      let _tempentry = this.emailRecipient.trim();

      let regex =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.name == undefined ||
        this.name == null ||
        this.name.length == 0
      ) {
        nameLabel.style.color = "red";
        this.nameError = true;
        validForm = false;
        window.scrollTo(0, top);
      } else {
        nameLabel.style.color = "black";
        this.nameError = false;
        validForm = true;
      }

      if (
        this.emailAddress == undefined ||
        this.emailAddress == null ||
        this.emailAddress.length == 0 ||
        !this.emailAddress.match(regex)
      ) {
        emailLabel.style.color = "red";
        this.emailAddressError = true;
        validForm = false;
        window.scrollTo(0, top);
      } else {
        emailLabel.style.color = "black";
        this.emailAddressError = false;
        validForm = true;
      }

      this.emailRecipient = _tempentry;
      if (this.validateEmail(this.emailRecipient)) {
        _hasre = true;
      }
      if (_hasre && this.recipients.length < 1) {
        this.recipients.push(this.emailRecipient);
      }
      if (this.recipients.length < 1 && !_hasre) {
        recipientLabel.style.color = "red";
        window.scrollTo(0, top);
        this.recipientsError = true;
        validForm = false;
      } else {
        recipientLabel.style.color = "black";
        this.recipientsError = false;
        validForm = true;
      }

      if (this.nameError || this.emailAddressError || this.recipientsError) {
        console.log("all fields error");
        errorMessage.style.display = "block";
        window.scrollTo(0, top);
        validForm = false;
      } else {
        errorMessage.style.display = "none";
        validForm = true;
      }

      if (validForm) {
        this.getPDF();
      } else {
        console.log("Not valid Form");
      }
    },
    getPDF() {
      var doc = new jsPDF();
      var x = 20;
      var y = 50;
      var today = new Date().toJSON();

      doc.setFontSize(10);
      doc.text(180, 285, "Page " + this.page++);

      doc.addImage(this.$parent.InverclydeHSCP, "png", 20, 10, 20, 20);

      doc.addImage(this.$parent.AlzheimerScotland, "png", 40, 9, 45, 24);

      doc.addImage(this.$parent.dhi, "png", 85, 16.5, 50, 12);

      doc.addImage(this.$parent.rds, "png", 145, 16.5, 37, 12);

      doc.setFontSize(20);
      this.boldText(
        "My wellbeing diary report from Living well with",
        x,
        y,
        doc
      );
      y = this.addY(y, 8, doc);

      doc.setFontSize(20);
      this.boldText("dementia app.", x, y, doc);
      y = this.addY(y, 12, doc);

      doc.setFontSize(16);
      doc.setTextColor(6, 69, 173);
      doc.textWithLink("https://dementiawellbeing.scot.nhs.uk/", x, y, {
        url: "https://dementiawellbeing.scot.nhs.uk/",
      });
      doc.setTextColor(0, 0, 0);
      y = this.addY(y, 16, doc);

      doc.setFontSize(16);
      doc.text(x, y, "Name: " + this.name);
      y = this.addY(y, 8, doc);

      doc.setFontSize(16);
      doc.text(x, y, "Email: " + this.emailAddress);
      y = this.addY(y, 8, doc);
      doc.setFontSize(11);
      doc.text(x, y, "Report created on " + helper.formatDateAndTime(today));
      doc.setFontSize(16);
      y = this.addY(y, 12, doc);

      doc.text(x, y, "Disclaimer:");
      y = this.addY(y, 5, doc);
      doc.setFontSize(11);
      doc.text(x, y, [
        "Scoring represents the person’s view of their wellbeing and is not a professional",
        "clinical assessment.",
      ]);
      y = this.addY(y, 16, doc);

      doc.setFontSize(18);
      this.boldText("Most recent response", x, y, doc);
      y = this.addY(y, 5, doc);

      doc.setFontSize(16);
      for (let i in this.$parent.statementAnswers) {
        let item = this.$parent.statementAnswers[i];
        y = this.addY(y, 8, doc);
        // x = 24;

        for (let s in item.data) {
          let statement = item.data[s];
          // let split = doc.splitTextToSize(statement.title, 170);
          doc.text(statement.title, x, y, doc);
          doc.setFontSize(11);
          y = this.addY(y, 8, doc);

          for (var _a in statement.answers) {
            let answer = statement.answers[_a];
            doc.text(
              x + 4,
              y,
              "• Answer: " +
                answer.answer +
                " (" +
                helper.formatDateAndTime(answer.date) +
                ")"
            );
            y = this.addY(y, 5, doc);
          }

          doc.setFontSize(14);
          y = this.addY(y, 3, doc);
        }

        doc.setFontSize(16);
        x = 20;
        y = this.addY(y, 2, doc);
      }

      doc.addPage();
      doc.setFontSize(10);
      doc.text(180, 285, "Page " + this.page++);

      x = 20;
      y = 25;
      doc.setFontSize(18);
      this.boldText("Responses over time", x, y, doc);
      y = this.addY(y, 5, doc);
      doc.setFontSize(11);
      doc.text(
        [
          'These graphs only show the last 7 answers for each statement. Please use the "Previous" arrow in the',
          "app to view earlier answers.",
        ],
        x,
        y,
        doc
      );

      y = this.addY(y, 26, doc);

      let a = 1;
      for (let i in this.$parent.statementAnswers) {
        let item = this.$parent.statementAnswers[i];

        for (let s in item.data) {
          let statement = item.data[s];
          this.addGraph(statement, x, y, doc);

          if (a % 2 == 0) {
            x = 20;
          } else {
            x += 55;
          }

          if (a % 2 == 0) {
            y = this.addY(y, 58, doc);
          }

          if (a % 15 == 0 && y > 25) {
            doc.addPage();
            doc.setFontSize(10);
            doc.text(180, 285, "Page " + this.page++);

            x = 20;
            y = 25;
            doc.setFontSize(18);
          }

          a++;
        }
      }

      this.sendEmail(doc);
      // this.downloadPDF(doc);
    },
    downloadPDF(doc) {
      doc.output("dataurlnewwindow");
    },
    testPDFDownload() {
      this.getPDF();
    },
    addY(y, by, doc) {
      if (y + by > 275) {
        doc.addPage();
        var fontSize = doc.getFontSize();
        doc.setFontSize(10);
        doc.text(180, 285, "Page " + this.page++);
        doc.setFontSize(fontSize);
        return 25;
      } else {
        return (y += by);
      }
    },
    boldText(text, x, y, doc) {
      doc.setFont(undefined, "bold");
      doc.text(x, y, text);
      doc.setFont(undefined, "normal");
    },
    addGraph(statement, x, y, doc) {
      doc.setFontSize(14);
      // let split = doc.splitTextToSize(statement.title, 48);
      // this.boldText(split[0] + (split.length > 1 ? "..." : ""), x, y, doc);
      var splitTitle = doc.splitTextToSize(statement.title, 50);
      this.boldText(splitTitle, x, y - 6, doc);
      // this.boldText(statement.title, x, y, doc);
      y = this.addY(y, 5, doc);

      doc.rect(x, y, 49.5, 30.5);
      doc.setDrawColor(200, 200, 200);

      doc.line(x, y + 8, x + 49, y + 8);
      doc.line(x, y + 15.5, x + 49, y + 15.5);
      doc.line(x, y + 23, x + 49, y + 23);

      doc.setDrawColor(0, 0, 0);
      var limit = 7;
      x = x + 42;
      for (var a in statement.answers) {
        if (limit == 0) {
          break;
        }
        let answer = statement.answers[a];
        let answerScore = null;
        let answerIcon = "";
        let _colour = [];

        if (answer.answer === "Agree") {
          answerScore = 2;
          answerIcon = this.$parent.agreeIcon;
          _colour = [214, 238, 229];
        } else if (answer.answer === "Neutral") {
          answerScore = 1;
          answerIcon = this.$parent.mehIcon;
          _colour = [251, 240, 226];
        } else if (answer.answer === "Disagree") {
          answerScore = 0;
          answerIcon = this.$parent.disagreeIcon;
          _colour = [249, 223, 223];
        } else if (answer.answer === "Not answered") {
          answerScore = -1;
          answerIcon = null;
          _colour = [0, 0, 0];
        }
        let date = helper.getChartDate(answer.date);
        doc.setFillColor(_colour[0], _colour[1], _colour[2]);
        doc.rect(
          x + 0.5,
          y + (3 - answerScore) * 7.5 + 0.5,
          6.5,
          (answerScore + 1) * 7.5,
          "F"
        );

        doc.setFontSize(8.5);
        if (answer.answer === "Agree" || answer.answer === "Neutral" || answer.answer === "Disagree") {
          doc.addImage(
            answerIcon,
            "png",
            x + 1,
            y + (3 - answerScore) * 7.5 + 1,
            6,
            6
          );
        }

        // doc.text(
        //   x + 3,
        //   y + (3 - answerScore) * 7.5 + 4.5
        // );

        doc.setFontSize(7);
        doc.text(x + 0.5, y + 33.5, date);
        doc.setFontSize(14);

        x = x - 7;
        limit--;
      }

      doc.setDrawColor(0, 0, 0);
    },
    removeEmail(idx) {
      this.recipients.splice(idx, 1);
    },
    addEmail() {
      console.log("add email called");
      let rep = this.emailRecipient.trim();
      if (this.validateEmail(rep)) {
        this.emailRecipient = "";
        let _eexist = false;
        this.recipients.forEach((e) => {
          if (rep.toLowerCase() === e.toLowerCase()) {
            _eexist = true;
          }
        });
        if (!_eexist) {
          this.recipients.push(rep);
          console.log(this.recipients);
        }
      }
    },
    shareViaEmail() {
      console.log("Share via email clicked");
      this.validateForm();
      // this.testPDFDownload();
      // console.log(this.$parent.statementAnswers.statements.data);
      // this.sendEmail();
    },
    sendEmail(doc) {
      console.log(window.rdsGlobal);
      console.log("send email clicked");
      this.emailSending = true;
      console.log("email is sending...");
      let success = document.getElementById("email-sent");
      let errorMessage = document.getElementById("email-error-send");
      let shareForm = document.getElementById("share_form");

      let info = {
        name: this.name,
        email: this.emailAddress,
      };

      let _pdfdata = doc
        .output("datauristring")
        .replace("data:application/pdf;filename=generated.pdf;base64,", "");
      console.log(_pdfdata);

      let htmlbody =
        "<p><strong>" +
        info.name +
        "</strong> has sent you this report on their wellbeing outcomes and how they have changed over time. The report has been created using the Living Well with Dementia app provided by Inverclyde Health and Social Care Partnership.</p>" +
        "<p>This app has been developed using the Right Decision Service provided by Healthcare Improvement Scotland.</p>" +
        "<p>If you experience any problems with receipt of this form or message, please contact his.decisionsupport@nhs.scot. Please do not send person-identifiable information to this email address.</p>";

      var model = {
        smtp: "smtp.sendgrid.net",
        port: 587,
        sendgrid_username: "apikey",
        sendgrid_password: "###SENDGRID###",
        to: [],
        from: {
          email: "donotreply@tactuum.com",
          name: "Decision Support",
        },
        replyto: [
          {
            email: this.emailAddress,
            name: this.name,
          },
        ],
        subject: "Wellbeing diary report",
        // body: btoa(htmlbody),
        body: htmlbody,
        attachments: [],
        response_title: "Email sent",
        response_body: "Your email with attachment has been sent successfully",
        response_buttontext: "Ok",
      };

      model.attachments.push({
        filename: "MyWellbeingDiary_Report.pdf",
        mimetype: "application/pdf",
        base64data: _pdfdata,
        isPdfFormat: true,
      });

      model.to.push({ email: this.emailAddress, name: this.emailAddress });

      this.recipients.forEach((em) => {
        model.to.push({ email: em, name: em });
      });

      console.log("emails sent to:" + " " + model.to[1]);

      let _unencrypted = JSON.stringify(model);
      //let _encrypted = this.encrypt(_unencrypted).toString();
      let _temp = btoa(_unencrypted.toString());

      // let _unencrypted = JSON.stringify(model);
      // let _temp = btoa(unescape(encodeURIComponent(_unencrypted)));
      console.log(_temp);
      // axios
      //   .post(
      //     "http://127.0.0.1:8989/datastore/sendemail",
      //     { data: _temp.toString(), },
      //     {
      //       headers: {
      //         "Content-Type":
      //           "application/x-www-form-urlencoded;charset=UTF-8;",
      //       },
      //     }
      //   )

      window.flutter_inappwebview.callHandler('SHARE', _temp).then(function(result) {
          console.log(result);
            window.scrollTo(0, top);
            success.style.display = "block";
            //formContent.style.display = "none";
            shareForm.style.display = "none";
            
        }).catch((error) => {
              console.log('failed' + error);
              window.scrollTo(0, top);
              errorMessage.style.display = "block";
              this.emailSending = false;
              //_callback({});
      });
        // axios
        //   .post(
        //     "https://tac-dhi-ivflu-liv.azurewebsites.net/umbraco/surface/review/sendreview/?key=" +
        //       "###APPKEY###",
        //       // "http://localhost:52105/umbraco/surface/review/sendreview/?key=" +
        //       // "###APPKEY###",
        //     { data: "'" + _temp.toString() + "'" },
        //     {
        //       headers: {
        //         "Content-Type": "application/x-www-form-urlencoded",
        //         Origin: "http://localhost:52105/",
        //       },
        //     }
        //   )
        // .then((r) => {
        //   console.log("response:" + " " + r);
        //   console.log(r.status);
        //   console.log(r.data);

        //   // window.scrollTo(0, top);
        //   // success.style.display = "block";
        //   // shareForm.style.display = "none";
        //   // this.resetForm();

        //   if (r.status === 200 && r.data === "success") {
        //     console.log("success");
        //     window.scrollTo(0, top);
        //     success.style.display = "block";
        //     shareForm.style.display = "none";
        //     this.resetForm();
        //   } else {
        //     console.log("failed!");
        //     window.scrollTo(0, top);
        //     errorMessage.style.display = "block";
        //     this.emailSending = false;
        //   }
        // })
        // .catch((error) => {
        //   window.scrollTo(0, top);
        //   errorMessage.style.display = "block";
        //   this.emailSending = false;
        //   console.log("failed2" + error);
        // });
    },
    encrypt(message) {
      let res = "";
      var secret = "###SELECTPDF###";
      var key = CryptoJS.enc.Utf8.parse(secret);
      var iv = CryptoJS.enc.Utf8.parse(secret);
      res = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(message), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return res;
    },
    decrypt(encrypted) {
      let res = "";
      let secret = "###SELECTPDF###";
      let key = CryptoJS.enc.Utf8.parse(secret);
      let iv = CryptoJS.enc.Utf8.parse(secret);
      var bytes = CryptoJS.AES.decrypt(encrypted, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      res = bytes.toString(CryptoJS.enc.Utf8);
      return res;
    },
  },
};
</script>